/**
 * @class
 */
export default class ResponseTemplate {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Faker} deps.faker
   * @param {Object} deps.libs
   */
  constructor({faker, libs} = {}) {
    this._faker = faker
    this._libs = libs
  }
}
